//@ts-nocheck
import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import PageTemplate from 'PageTemplates/PageTemplate';
import { PageHeader } from 'components/header';
import Spinner from 'components/spinner';

// Components
import OrderInfoCard from './components/OrderInfoCard';
import OrderSummaryCard from './components/OrderSummaryCard';
import OrderItemsTable from './components/OrderItemsTable';

// Hooks
import { useStorageOrderDetail } from './hooks/useStorageOrderDetail';

// Components for modals
import ConfirmationModal from 'components/modals/ConfirmationModal';

// Utils
import {
  formatDate,
  getStatusBadge,
  calculateTotalValue,
  calculateTotalItems,
} from './utils/orderUtils';

const StorageOrderDetail = () => {
  const { orderId } = useParams();
  const history = useHistory();
  const {
    order,
    loading,
    handleCompleteOrder,
    handleSendOrder,
    handleDownloadPdf,
    handleBack,
    showCompleteModal,
    setShowCompleteModal,
    showSendModal,
    setShowSendModal,
  } = useStorageOrderDetail(orderId);

  if (loading) {
    return (
      <PageTemplate>
        <div className="d-flex justify-content-center my-4">
          <Spinner />
        </div>
      </PageTemplate>
    );
  }

  if (!order) {
    return (
      <PageTemplate>
        <Container>
          <div className="text-center my-4">
            <p>Nie znaleziono zamówienia</p>
            <Button variant="primary" onClick={handleBack}>
              Powrót do listy
            </Button>
          </div>
        </Container>
      </PageTemplate>
    );
  }

  return (
    <PageTemplate>
      <PageHeader
        title={`Zamówienie ${order.number}`}
        extra={[
          <Button
            key="back"
            variant="outline-secondary"
            onClick={handleBack}
          >
            Powrót
          </Button>,
          order.status !== 'odebrano' && order.status !== 'completed' && (
            <Button
              key="download"
              variant="outline-primary"
              onClick={handleDownloadPdf}
            >
              Pobierz PDF
            </Button>
          ),
          order.status === 'oczekuje' && (
            <Button
              key="edit"
              variant="outline-warning"
              onClick={() =>
                history.push(`/storage/orders/${orderId}/edit`)
              }
            >
              Edytuj
            </Button>
          ),
          (order.status === 'pending' || order.status === 'oczekuje') && (
            <Button
              key="send"
              variant="success"
              onClick={() => setShowSendModal(true)}
            >
              Zamów
            </Button>
          ),
          (order.status === 'inProgress' ||
            order.status === 'w realizacji') && (
            <Button
              key="receive"
              variant="success"
              onClick={() =>
                history.push(`/storage/orders/${orderId}/receive`)
              }
            >
              Odbierz
            </Button>
          ),
        ]}
      />

      <Container fluid>
        <Row>
          <Col md={4}>
            <OrderInfoCard
              order={order}
              formatDate={formatDate}
              getStatusBadge={getStatusBadge}
            />
            <OrderSummaryCard
              order={order}
              calculateTotalValue={() => calculateTotalValue(order.items)}
              calculateTotalItems={() => calculateTotalItems(order.items)}
            />
          </Col>

          <Col md={8}>
            <OrderItemsTable
              order={order}
              calculateTotalValue={() => calculateTotalValue(order.items)}
              calculateTotalItems={() => calculateTotalItems(order.items)}
            />
          </Col>
        </Row>
      </Container>

      {/* Modały potwierdzenia */}
      {showSendModal && (
        <ConfirmationModal
          title="Wysyłanie zamówienia"
          description="Czy na pewno chcesz wysłać to zamówienie do realizacji?"
          closeModal={() => setShowSendModal(false)}
          handleSubmit={handleSendOrder}
        />
      )}

      {showCompleteModal && (
        <ConfirmationModal
          title="Realizacja zamówienia"
          description="Czy na pewno chcesz zrealizować to zamówienie? Ta operacja zaktualizuje stan magazynu."
          closeModal={() => setShowCompleteModal(false)}
          handleSubmit={handleCompleteOrder}
        />
      )}
    </PageTemplate>
  );
};

export default StorageOrderDetail;
